export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_2240kbps-5badb24b1d9872179b015ebf8ce83c6e.avif";